import React from 'react'
import { useSelector } from 'react-redux'
import { CSVLink } from 'react-csv'
import { buildCsvString } from '../../utils/csv'
import { formatFavouriteForCsv } from '../../utils/parseShoppingListCsvRow'
import { Button } from 'antd'
import moment from 'moment'

const DownloadProductsCsv = ({ venueProducts }) => {
  const { title } = useSelector(state => state.venue.venue)
  const headerOfFile = `Shopping List - ${title}`
  const headers = [
    'Product ID',
    'Product',
    'Zone',
    'Default qty',
    'Size',
    'Price',
    'Special price',
    'Has special price',
    'Priced By',
    'Supplier',
    'SKU',
    'Type',
    'Favourite',
    'Nominal Code',
  ]
  const rows = []
  rows.push([headerOfFile])
  rows.push([])
  rows.push(headers)

  venueProducts?.forEach(product => {
    const productInfo = product?.product || {}
    const { size, price, sku, pricedBy } = productInfo
    const brakesPrice = product?.brakesPrice

    // Determine if special price is active (TRUE/FALSE)
    const hasActiveSpecialPrice =
      product.specialPrice != null &&
      !isNaN(product.specialPrice) &&
      Number(product.specialPrice) > 0

    const specialPriceFlag = hasActiveSpecialPrice ? 'TRUE' : 'FALSE'

    // Format special price display value (numeric)
    const specialPriceValue = hasActiveSpecialPrice
      ? Number(product.specialPrice).toFixed(2)
      : '0.00'

    rows.push([
      (product.product && product.product._id) || '',
      product.title,
      product.zone || '',
      product.defaultQuantity || '',
      size,
      Number((Number(brakesPrice) > 0 ? brakesPrice : price) || 0).toFixed(2),
      specialPriceValue,
      specialPriceFlag,
      pricedBy || '',
      product.supplierTitle,
      sku,
      product.type,
      formatFavouriteForCsv(product.isFavourite),
      product.nominalCode || '',
    ])
  })
  const csvString = buildCsvString(rows)

  const timestamp = moment().format('YYYY-MM-DD_HH-mm')
  const venueSlug = title.toLowerCase().replace(/\s+/g, '-')
  const filename = `shopping-list_${venueSlug}_${timestamp}.csv`

  return (
    <Button>
      <CSVLink data={csvString} filename={filename}>
        Download CSV
      </CSVLink>
    </Button>
  )
}

export default DownloadProductsCsv
